module.exports = __webpack_public_path__ + "img/신현리 네일.6bcab821.png";